<main class="bg-white position-relative">
  <!-- search bar -->
  <div class="container">
    <div class="confirmation-sec padd-top-bot">
      <div class="col-md-7">
        <div class="receive-sec">
          <i class="flaticon-checked"></i>
          <h2>We’ve received your order</h2>
          <p>Order No. : <span>#758756467564154</span></p>
        </div>
        <div class="order-info">
          <h3>Delivery Details</h3>
          <div class="row">
            <div class="col-md-6 delivery-detail">
              <h4>First Name</h4>
              <p>Smith Jhon</p>
            </div>
            <div class="col-md-6 delivery-detail">
              <h4>Delivery Method</h4>
              <p>Local Pickup (Free)</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 delivery-detail">
              <h4>Phone Number</h4>
              <p>(+44) 444 555 666</p>
            </div>
            <div class="col-md-6 delivery-detail">
              <h4>Email Address</h4>
              <p>smithjhon@gmail.com</p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 delivery-detail">
              <h4>Address</h4>
              <p>581 Swauger Valley Rd, Portsmouth, OH, 45662</p>
            </div>
            <div class="col-md-6 delivery-detail">
            </div>
          </div>
          <div class="order-summery">
            <h4>Order Summary</h4>
            <table>
              <tbody>
              <tr>
                <td>Off-White x Wmns Air Zoom</td>
                <td>$222.00</td>
              </tr>
              <tr>
                <td>Off-White x Wmns Air Zoom</td>
                <td>$222.00</td>
              </tr>
              <tr>
                <td>Shipping</td>
                <td>Local Pickup (Free)</td>
              </tr>
              <tr>
                <td>Subtotal</td>
                <td>$444.00</td>
              </tr>
              <tr class="total">
                <td>Total</td>
                <td>$444.00</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="payment-information">
            <h3>Payment Information</h3>
            <div class="row">
              <div class="col-md-6 delivery-detail">
                <h4>Credit Card</h4>
                <p>Visa ********7878</p>
              </div>
              <div class="col-md-6 delivery-detail">
                <h4>Billing Address</h4>
                <p>5290 Betts Rd, Greenbrier, TN, 37073</p>
              </div>
            </div>
          </div>
        </div>
        <div class="payment-btn">
          <a routerLink="/thank-you">Process</a>
        </div>
      </div>
    </div>
  </div>
  <!-- top_selling_sec -->
</main>
